<template lang="pug">
    div.logoWrapper
        router-link.logo(to="/themes" v-if="type === 'dashboard' || type === 'auth'")
            div
                img(
                    alt="Company Logo"
                    v-if="type === 'dashboard'"
                    :src="logoChill"
                    class="dashboard-logo"
                )
                img(
                    alt="Company Logo"
                    v-if="type === 'auth'"
                    :src="logoChill"
                    class="auth-logo"
                )

        div(v-if="type === 'help'")
            img(
                alt="Company Logo"
                :src="logoChill"
                class="help"
            )

        div(v-if="type === 'gympass'")
            img(
                alt="Company Logo"
                :src="logoChill"
                class="gympass"
            )
</template>

<script>
    import VueTypes from 'vue-types';
    import logoChill from './images/logo.svg';

    export default {
        props: {
            type: VueTypes.string.def('auth')
        },
        data() {
            return {
                logoChill
            };
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../assets/style/_variables.styl";

    .logoWrapper
        display: flex
        align-items: center
    .logo
        display: inline-block

    .auth-logo
        margin-right: 15px
        width: 230px

    .dashboard-logo
        margin-right: 40px
        width: 195px

    .help
        margin: 15px
        width: 340px

    .gympass
        margin: 10px
        width: 290px

    @media screen and (max-width: $grid-breakpoints.md - 1)
        .dashboard-logo
            margin-top: 10px
            margin-right: 20px
            width: 110px

        .help
            width: 220px
</style>
